<template>
    <div class="login_bg">
        <div class="login_inner">
            <div class="login_bg_txt">
                <h3 class="permanent-marker-regular">{{ $store.getters.t('Manage Videos') }}</h3>
                <h1>{{ $store.getters.t('VIDEO PLATFORM') }}</h1>
            </div>
            <div class="kcinfra">
                <span>©KCINFRA. ALL RIGHTS RESERVED.</span>
            </div>
            <div class="bg_img">
                <v-img class="icon01" src="./../../styles/icon01.png" />
                <v-img class="icon02" src="./../../styles/icon02.png" />
                <v-img class="icon03" src="./../../styles/icon03.png" />
                <v-img class="icon04" src="./../../styles/icon04.png" />
            </div>
            
            <div class="login_box">
                <div class="login_right">
                    <v-form @submit.prevent="submitLogin" class="login_form">
                        <div class="login_title">
                            <h1>{{ $store.getters.t('LOGIN') }}</h1>
                            <span>{{ $store.getters.t('비디오 플랫폼에 오신 것을 환영합니다.') }}</span>
                        </div>
                        <v-text-field v-model="email" :label="$store.getters.t('이메일')" :rules="emailRules" outlined style="height: 82px;"/>

                        <v-text-field v-model="password" :label="$store.getters.t('암호')" outlined style="height: 82px;"
                            type="password" :rules="passwordRules"/>

                        <v-btn :loading="loading" type="submit" color="#007bff" depressed x-large block class="mb-2 mt-1" dark>
                            {{ $store.getters.t('로그인') }}
                        </v-btn>
                        <FindPasswordForm />
                    </v-form>

                    <AppConfirmDialog v-model="showConfirmationDialog" :title="confirmationTitle"
                        :message="confirmationMessage" @confirm="handleConfirm" />
                </div>
            </div>
    </div>
</div>
</template>

<script>
import FindPasswordForm from '@/components/user/FindPasswordForm.vue';
import { mapActions } from 'vuex';
import AppConfirmDialog from '@/components/app/AppConfirmDialog.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';



export default {
    components: {
        TextButtonBlock,
    },
    data() {
        return {
            email: '',
            password: '',
            showConfirmationDialog: false,
            confirmationTitle: '',
            confirmationMessage: '',
            loading: false,
        };
    },
    components: {
        FindPasswordForm,
        AppConfirmDialog
    },
    methods: {
        ...mapActions('user', ['login']),
        submitLogin() {
            this.loading = true;
        this.login({ email: this.email, password: this.password })
            .then((data) => {
                    // this.$router.push({ path: '/dashboard' });
                    if (this.$route.path !== '/dashboard') {
                        this.$router.push('/dashboard').catch(err => {
                            if (err.name !== 'NavigationDuplicated') throw err;
                        });
                        }
            })
            .catch(error => {
                //console.error('error:', error);
                this.confirmationTitle = this.$store.getters.t('로그인 실패');
                this.confirmationMessage = error.response && error.response.data.message
                    ? error.response.data.message
                    : this.$store.getters.t('로그인 과정에서 오류가 발생했습니다. 다시 시도해 주세요.');
                this.showConfirmationDialog = true;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        handleConfirm() {
            this.showConfirmationDialog = false;
            this.email = '';
            this.password = '';
        },
    },
    computed: {
        emailRules() {
            return [
                v => !v || /.+@.+\..+/.test(v) || this.$store.getters.t('이메일 주소를 정확히 입력해주세요.'),
            ];
        },
        passwordRules() {
            return [
                v => !v || /[!@#$%^&*(),.?":{}|<>]/.test(v) || this.$store.getters.t('영문, 숫자, 특수문자를 조합하여 입력해주세요.'),
            ];
        }
    }
};
</script>

<style scoped>
.login_bg {
    /* background-image: url(./../../styles/login_background.png);
    background-size: cover; */
    height: 100vh;
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
}

.login_bg_txt {
    position: absolute;
    top:60px;
    text-align: center;
}
.login_bg_txt h1 {
    font-family: 'SBAggroB';
    color: #ffffff;
    font-size: clamp(60px, 6vw, 8vw);
    opacity: 0.25;
    padding: 0 24px;
    line-height: 120%;
}
.login_bg_txt h3 {
    font-size: clamp(28px, 2vw, 3vw);
    color: #fff;
}

.kcinfra { 
    position: absolute;
    bottom: 20px;
    color: #999;
 }

.login_inner {
    width: 100%;
    height: 100vh;
    background: linear-gradient(to bottom, #007bff 0%, #007bff 80%, #ffffff 50%, #ffffff 100%);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
}
.login_box {
    width: 100%;
    max-width: 500px;
    margin-top: 200px;
    display: flex;
    justify-content: center;
}

.login_title{
    text-align: center;
    margin-bottom: 40px;
}
.login_title h1 {
    font-size: 40px;
    color: #007bff;
    margin-bottom: 8px;
}
.login_title span{
    color: #888;
    font-size: 18px;
}

.login_right{
    height: 56vh;
    width: 100%;
    background: #fff;
    padding: 36px;
    display: grid;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.login_form{
    width: 360px;
}

.bg_img {
    opacity: 0.3;
    position: absolute;
    width:100%;
    height: 80vh;
}

.bg_img .icon01 {
    position: absolute;
    top: 35%;
    left: 25%;
    width:7vw;
}
.bg_img .icon02 {
    position: absolute;
    top: 40%;
    right: 25%;
    width:7vw;
}
.bg_img .icon03 {
    position: absolute;
    top: 55%;
    left: 15%;
    width:7vw;
}
.bg_img .icon04 {
    position: absolute;
    top: 60%;
    right: 15%;
    width:7vw;
}

/* @media only screen and (max-width: 780px) {
    .login_title{justify-content: center;display: flex;}
    .login_left {display: none;}
    .login_right {border-radius: 10px;width: 360px;}
} */

@media only screen and (max-width: 1440px) {
    .login_box { margin-top: 150px }
}
@media only screen and (max-width: 1280px) {
    .login_box { margin-top: 100px }
}
@media only screen and (max-width: 600px) {
    .login_bg_txt h3 { margin-bottom: 12px; }
    .login_right { width: 100%; }
    .login_box { padding: 80px 24px 0 }
    .login_form { width:300px }

    .bg_img .icon01 {
        top: 3%;
        left: 5%;
        width: 48px;
    }
    .bg_img .icon02 {
        top: -58px;
        right: 5%;
        width:48px;
    }
    .bg_img .icon03 {
        top: -58px;
        left: 4;
        width:48px;
    }
    .bg_img .icon04 {
        top: 3%;
        right: 10%;
        width:48px;
    }
}
</style>
